module.exports = __webpack_public_path__ + "static/media/Antique-elegant-dress-422029.fa434cfd.jpg";